export const SOCIALS = [
  {
    icon: "ri-linkedin-box-line",
    link: "https://www.linkedin.com/in/jagannathbhatjb/",
    title: "hire me please!",
  },
  {
    icon: "ri-github-line",
    link: "https://github.com/jagannathBhat",
    title: "repos i would like people to know about",
  },
  {
    icon: "ri-gitlab-line",
    link: "https://gitlab.com/jagannathBhat",
    title: "repos i do not care to tell people about",
  },
  {
    icon: "ri-instagram-line",
    link: "https://instagram.com/jagannathbhatjb",
    title: "if one photo of me isn't enough",
  },
  {
    icon: "ri-youtube-line",
    link: "https://youtube.com/@jagannathbhatjb",
    title: "i make videos whenever i feel like it",
  },
];

export const PROJECTS = [
  {
    description: "Cloud Function to check for new vaccination slots",
    name: "CoWin",
    repoURL: "https://gitlab.com/cowin",
    projectURL: "https://cowinjb.web.app/",
    topics: [
      "Firebase",
      "Firebase cloud function",
      "Firebase cloud messaging",
      "Cloud function",
      "Cloud messaging",
    ],
  },
  {
    description:
      "Private Bus Concession Card generator for Adi Shankara Institute of Engineering and Technology",
    name: "Genc-asiet",
    repoURL: "https://gitlab.com/hexify/genc-asiet",
    projectURL: "https://hexify.tech/genc-asiet",
    topics: ["Technology", "Electron", "React", "Material UI", "Pouch DB"],
  },
  {
    description: "Common Vulnerability Scoring System based calculator",
    name: "cvss",
    repoURL: "https://github.com/jagannathBhat/cvss",
    projectURL: "https://cvss.bhat.dev",
    topics: ["Calculator", "CVSS"],
  },
  {
    description: "Template for Create React App with Redux and Material-UI",
    name: "cra-template-rrm",
    repoURL: "https://github.com/jagannathBhat/cra-template-rrm",
    projectURL: "https://www.npmjs.com/package/cra-template-rrm",
    topics: ["npm-package", "react-template", "create-react-app-template"],
  },
  {
    description:
      "ODC is a system for Govt. schools to collect students' data and send it to Govt. officials. ODC works can be used to collect data even when offline. The data will be sent automatically when the app comes back online.",
    name: "odc",
    repoURL: "https://github.com/jagannathBhat/odc",
    projectURL: "https://odc-shool.netlify.app/",
    topics: ["react", "pouchDB"],
  },
  {
    description:
      "Help people determine if a tumor on their skin is Benign or Malignant",
    name: "benant",
    repoURL: "https://github.com/jagannathBhat/benant",
    topics: [
      "react",
      "flask",
      "machine learning",
      "reactjs",
      "tensorflow",
      "keras",
      "skin-cancer",
    ],
  },
  {
    description:
      "Download the anime you want from AnimeYoutube without any of the ads. This project is not production ready because of some issues. Please check the issues section if you can help me out with any of them",
    name: "anime youtube downloader",
    repoURL: "https://github.com/jagannathBhat/animeyoutube-downloader",
    topics: [
      "react",
      "flast ",
      "reactjs",
      "anime",
      "webscraping",
      "anime-downloader",
      "anime-scraper",
    ],
  },
  {
    description:
      "NPM package - Boilerplate for making web apps with React, Redux and Material-UI",
    name: "rrm-app",
    repoURL: "https://github.com/jagannathBhat/rrm-app",
    projectURL: "https://www.npmjs.com/package/rrm-app",
    topics: ["react", "redux", "boilerplate", "material-ui", "npm-package"],
  },
  {
    description:
      "NodeJS script to generate certificates in PDF format from am SVG template",
    name: "certificate generator",
    repoURL: "https://github.com/jagannathBhat/certificate-generator",
    topics: ["nodejs", "pdfkit"],
  },
  {
    description:
      "A web app that generates Time Tables using a Genetic Algorithm",
    name: "fit-tables",
    repoURL: "https://github.com/jagannathBhat/fit-tables",
    topics: [
      "react ",
      "flask",
      "reactjs",
      "genetic-algorithm",
      "timetable-generato",
    ],
  },
  {
    description:
      "This is repo contains the website for the technical fest of Adi Shankara Institute of Engineering and Technology",
    name: "ashwamedha",
    repoURL: "https://github.com/jagannathBhat/Ashwamedha19",
    projectURL: "https://jagannathbhat.github.io/Ashwamedha19/",
    topics: [],
  },
  {
    description: "Website for the hackathon Hack Camp 1.0",
    name: "hackCamp1",
    repoURL: "https://github.com/jagannathBhat/hackCamp1",
    projectURL: "https://jagannathbhat.github.io/hackCamp1/",
    topics: [],
  },
  {
    description:
      "Concept website for a company called OpenSale that runs cashier-less stores",
    name: "OpenSale",
    repoURL: "https://gitlab.com/jagannathbhat/opensale",
    projectURL: "https://jagannathbhat.gitlab.io/opensale",
    topics: [],
  },
  {
    description:
      "Offline persistent database for react native based on Async Storage. Developed by combining PouchDB and Async Storage.",
    name: "async-storage-db",
    repoURL: "https://github.com/jagannathBhat/async-storage-db",
    projectURL: "https://www.npmjs.com/package/async-storage-db",
    topics: ["node js", "npm", "react-native", "npm-package"],
  },
];
